import axios from "axios"
import { domain_backend } from "const";
import { getCookie } from "general_function";
import toastr from "toastr";

const API = axios.create({
    baseURL: domain_backend,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    },
})

API.interceptors.request.use(
    (config) => {
        const token = getCookie('usertoken')
        if (token) {
            const proxy = getCookie('proxyuser')
            config.headers['Authorization'] = `Token ${token}${proxy ? `-${proxy}` : ""}`
        }
        return config;
    }
)

API.interceptors.response.use(undefined, (error) => {
    const { response } = error
    if (!response) {
        toastr.error("Không thể kết nối với máy chủ, vui lòng liên hệ với admin!")
        return Promise.reject({ response: null })
    }
    if (response.status === 500) {
        toastr.error("Lỗi máy chủ, vui lòng liên hệ với admin")
        return Promise.reject({ response: null })
    }
    // if (response.data.detail && response.data.detail === "Token has expired") {
    //     logout()
    //     setFunction.setShowLogoutWarning("expired")
    //     return Promise.reject({ response: null })
    // }
    // if (response.data.detail && response.data.detail === "Invalid token") {
    //     logout()
    //     setFunction.setShowLogoutWarning("logout")
    //     return Promise.reject({ response: null })
    // }
    if (response.data.detail && response.data.detail === "Authentication credentials were not provided.") {
        toastr.error("Bạn cần đăng nhập để sử dụng tính năng này!")
        return Promise.reject({ response: null })
    }
    if (response.status === 403) {
        toastr.error("Bạn không có quyền sử dụng tính năng này!")
        return Promise.reject({ response: null })
    }
    return Promise.reject(error)
})

export default API